import { Dispatch, SetStateAction } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SidebarIcon, SidebarNavLinks } from '../../../helpers/helperFunctions';
import { DASHBOARD } from '../../../routes/routes';
import { P2 } from '../../../styles/FontStyles';
import { colors, globalImages } from '../../../styles/GlobalStyles';
import { Icon } from '../../../styles/Icons';
import { FlexCenter } from '../../../styles/stylesStyled';
import { SideButtonsContent } from '../BackofficeLayoutStyled';
import { Flexed } from '../../../styles/GlobalComponents';

interface SidebarNavContentProps {
  onClose: Dispatch<SetStateAction<boolean>>;
}

export const SidebarNavContent = ({ onClose }: SidebarNavContentProps) => {
  const location = useLocation();
  const pathname = location.pathname;

  const sidebarNavLinks = SidebarNavLinks();

  return (
    <SideButtonsContent>
      {sidebarNavLinks.map(({ link, name, disabled, hidden }, i) => {
        if (hidden) return null;

        return (
          <Link
            to={link}
            key={i}
            style={{
              pointerEvents: disabled ? 'none' : 'auto'
            }}
            onClick={() => onClose(false)}>
            <Flexed
              height='50px'
              center
              style={{
                opacity: disabled ? 0.3 : 1
              }}>
              <Icon
                m='0 15px'
                mSM='0 20px'
                w='32px'
                color={link === pathname ? colors.primary900 : colors.neutral0}>
                <SidebarIcon link={name} />
              </Icon>
              <P2
                semiBold
                color={link === pathname ? colors.primary900 : colors.neutral0}>
                {name}
              </P2>
            </Flexed>
          </Link>
        );
      })}
    </SideButtonsContent>
  );
};
